import React from 'react';
import { useT } from '../../../../i18n';

const STEPS = [
  { time: '15:00', label: 'Cérémonie' },
  { time: '17:00', label: 'Cocktail' },
  { time: '19:30', label: 'Dîner' },
  { time: '23:00', label: 'Ouverture du bal' },
];

// Déroulé du jour J : le repère « maintenant » avance dans la journée.
const DayplanVisual: React.FC = () => {
  const t = useT();
  return (
    <div className="mk-fv-box mk-fv-dayplan">
      <span className="mk-fv-dayplan-line" />
      <span className="mk-fv-now">
        <i />
      </span>
      {STEPS.map((s) => (
        <div key={s.time} className="mk-fv-dayplan-step">
          <em>{s.time}</em>
          {t(s.label)}
        </div>
      ))}
    </div>
  );
};

export default DayplanVisual;
